import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

/**
 * ==========================================================
 * AppLoader
 * ==========================================================
 *
 * Full screen loader used during:
 * - App startup
 * - Auth initialization
 * - Initial data loading
 *
 * ==========================================================
 */

const AppLoader = () => {
  // i18n is bootstrapped in src/index.js before <App /> mounts, so this is safe
  // here — and this is the FIRST thing every user sees, in every language.
  const { t } = useTranslation("common");

  return (

    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        bgcolor: "background.default"
      }}
    >

      <CircularProgress size={60} />

      <Typography
        variant="body1"
        sx={{ mt: 2 }}
      >
        {t("loadingApp")}
      </Typography>

    </Box>

  );

};

export default AppLoader;
